import Api from '@/services/api-service';
import route from '@/router';

export default {
  state: {
    items: [],
    adding: false,
    count: 0,
    total: 0,
    currency: 'AMD',
    shipping_cost: 1000
  },
  mutations: {
    SET_CART_ITEM (state, item) {
      state.items.unshift(item);
    },
    RESET_CART (state) {
      state.items = [];
    },
    UPDATE_CART_ITEM_QTY (state, data) {
      state.items[data.index].qty = data.qty;
      state.items[data.index].stock = data.stock;
    },
    UPDATE_CART_ITEM_PRICE (state, data) {
      state.items[data.index].price = data.price;
    },
    SET_CART_TOTALS (state) {
      var qty = 0;
      var total = 0;
      for (var key in state.items) {
        qty += state.items[key].qty;
        total += state.items[key].qty * state.items[key].price;
      }
      state.count = qty;
      state.total = total;
      state.shipping_cost = 4000;
    },
    REMOVE_CART_ITEM: function (state, index) {
      state.items.splice(index, 1);
    }
  },
  actions: {
    fetchCartItem ({
      commit,
      state,
      getters
    }, item) {
      var cart_item = getters.getCartItem(item);
      if (!cart_item) {
        commit('SET_CART_ITEM', item);
      } else {
        var qty = cart_item.qty + item.qty;
        var index = state.items.indexOf(cart_item);
        commit('UPDATE_CART_ITEM_QTY', {
          qty: qty,
          index: index
        });
      }
      commit('SET_CART_TOTALS');
    },
    fetchCartItemQty ({
      commit,
      state,
      getters
    }, item) {
      var cart_item = getters.getCartItem(item);
      var index = state.items.indexOf(cart_item);
      commit('UPDATE_CART_ITEM_QTY', {
        qty: item.qty,
        stock: item.stock,
        index: index
      });
      commit('SET_CART_TOTALS');
    },
    removeCartItemQty ({
      commit,
      state,
      getters
    }, item) {
      var cart_item = getters.getCartItem(item);
      if (cart_item) {
        var index = state.items.indexOf(cart_item);
        commit('REMOVE_CART_ITEM', index);
        commit('SET_CART_TOTALS');
      }
    },
    resetCart ({
      commit
    }) {
      commit('RESET_CART');
      commit('SET_CART_TOTALS');
    },
    async updateCartPrices ({ commit, state }) {
      try {
        for (const [index, item] of state.items.entries()) {
          const payload = {
            query: {},
            params: {
              product: item.item_id
            }
          };

          const { data } = await Api.post('data/product', payload);

          if (data && data.page && data.page.response && data.page.response.product) {
            const product = data.page.response.product;

            const price = parseFloat(product.price);
            if (!isNaN(price)) {
              commit('UPDATE_CART_ITEM_PRICE', { index, price });
            } else {
              console.error(`Invalid price for product ID ${item.item_id}:`, product.price);
            }
          } else {
            console.error(`No product data found for item ID ${item.item_id}:`, data);
          }
        }
        commit('SET_CART_TOTALS');
      } catch (error) {
        console.error('Failed to update cart prices:', error);
      }
    }
  },
  getters: {
    // eslint-disable-next-line camelcase
    getCartItem: state => cart_item => {
      return state.items.find(item => item.item_id === cart_item.item_id);
    }
  }
};
